// extracted by mini-css-extract-plugin
export default {"dots_container":"Loader_dots_container__xU9TZ","dot":"Loader_dot__-U-2g","pulse":"Loader_pulse__FEm+J"};